<template>
	<div class="indexBar">
		<back-to></back-to>
		<van-index-bar :index-list="indexList" :sticky-offset-top="45">
			<section v-for="(item,index) in cityList" :key="index">
				<van-index-anchor :index="item.wordType" />
				<!-- <van-cell v-for="(val,key) in item.countList" :key="key" :title="val.areaName" /> -->
				<van-cell v-for="(val,key) in item.countList" :key="key"
					@click="$router.push({ path: '/passhot',query:{areaId:val.areaId}})">
					<!-- 使用 title 插槽来自定义标题 -->
					<template #title>
						<span class="custom-title">
							<img :src="val.areaImg" alt="">
							<p>{{val.areaName}}</p>
						</span>
					</template>
				</van-cell>
			</section>
		</van-index-bar>
	</div>
</template>

<script>
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'indexBar',
		components: {
			BackTo
		},
		data() {
			return {
				cityList: [],
				indexList: []
			}
		},
		computed: {

		},
		mounted() {
			this.getContent()
		},
		methods: {
			getContent() {
				var mydata = {
					"tohrequest": {
						"callid": "141027",
						"transid": "1555289619872",
						"timestamp": "1555289619872",
						"ostype": "1",
						"imei": "imei",
						"imsi": "imsi",
						"version": "4.0.4",
						"svccont": {
							"userId": ""
						}
					}
				}
				this.$post(
					this.$service + '/m/m_Service.asmx/M_InterfaceTrue', {
						s: JSON.stringify(mydata)
					}
				).then(res => {
					let jsArr = JSON.parse(res.d).tohresponse
					this.cityList = jsArr.svccont.unitList
					let searchNav = []
					for (let i in jsArr.svccont.unitList) {
						searchNav.push(jsArr.svccont.unitList[i].wordType)
					}
					this.indexList = searchNav
					console.log(searchNav)
					console.log(jsArr.svccont.unitList)
				})
			}
		}
	}
</script>
<style>
	.indexBar .van-index-anchor {
		background-color: #f4f4f4 !important;
	}

	.indexBar .van-index-bar__index {
		line-height: 48px;
	}

	.custom-title {
		display: flex;
		align-items: center;
		font-size: 28px;
	}

	.custom-title img {
		width: 134px;
		height: 90px;
		margin-right: 10px;
	}
</style>
